import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {FeatureTaxCorporateDetailsComponent} from './tax-corporate-details/feature-tax-corporate-details.component';
import {CorporateComponent} from './corporate/corporate.component';
import {AlgemeenComponent} from './corporate/algemeen/algemeen.component';
import {BelastingplichtigeComponent} from './corporate/belastingplichtige/belastingplichtige.component';
import {VragenFiscaleEenheidComponent} from './corporate/vragen-fiscale-eenheid/vragen-fiscale-eenheid.component';
import {ResultatenRekeningComponent} from './corporate/resultaten-rekening/resultaten-rekening.component';
import {VermogensVergelijkingComponent} from './corporate/vermogens-vergelijking/vermogens-vergelijking.component';
import {AandeelhoudersComponent} from './corporate/aandeelhouders/aandeelhouders.component';
import {DeelnemingenComponent} from './corporate/deelnemingen/deelnemingen.component';
import {InvesteringenComponent} from './corporate/investeringen/investeringen.component';
import {BelastingBedragComponent} from './corporate/belasting-bedrag/belasting-bedrag.component';
import {BalansActivaComponent} from './corporate/balans-activa/balans-activa.component';
import {BalansPassivaComponent} from './corporate/balans-passiva/balans-passiva.component';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {DividendsComponent} from './corporate/dividends/dividends.component';
import {
  BeperktAftrekbareKostenComponent
} from './corporate/beperkt-aftrekbare-kosten/beperkt-aftrekbare-kosten.component';
import {VerliezenComponent} from './corporate/verliezen/verliezen.component';
import {OverigeKostenComponent} from './corporate/beperkt-aftrekbare-kosten/overige-kosten/overige-kosten.component';
import {RenteComponent} from './corporate/beperkt-aftrekbare-kosten/rente/rente.component';
import {WillekeurigAfschrijvenComponent} from './corporate/willekeurig-afschrijven/willekeurig-afschrijven.component';
import {FunctioneleValutaComponent} from './corporate/functionele-valuta/functionele-valuta.component';
import {FiscaleEenheidVoegingComponent} from './corporate/fiscale-eenheid-voeging/fiscale-eenheid-voeging.component';
import {
  FiscaleEenheidOntvoegingComponent
} from './corporate/fiscale-eenheid-ontvoeging/fiscale-eenheid-ontvoeging.component';
import {
  FiscaleEenheidOntbindingComponent
} from './corporate/fiscale-eenheid-ontbinding/fiscale-eenheid-ontbinding.component';
import {InnovatieboxComponent} from './corporate/innovatiebox/innovatiebox.component';
import {BronheffingComponent} from './corporate/bronheffing/bronheffing.component';
import {EnkelvoudigeCijfersComponent} from './corporate/enkelvoudige-cijfers/enkelvoudige-cijfers.component';
import {SpecOmzetbelastingComponent} from './corporate/spec-omzetbelasting/spec-omzetbelasting.component';
import {SpecHirComponent} from './corporate/spec-hir/spec-hir.component';
import {
  SpecGarantievoorzieningComponent
} from './corporate/spec-garantievoorziening/spec-garantievoorziening.component';
import {SpecKerComponent} from './corporate/spec-ker/spec-ker.component';
import {SpecCompartimenteringComponent} from './corporate/spec-compartimentering/spec-compartimentering.component';
import {SpecOverigeVoorzieningComponent} from './corporate/spec-overige-voorziening/spec-overige-voorziening.component';
import {SpecHir2Component} from './corporate/spec-hir-2/spec-hir-2.component';
import {
  FiscaleEenheidSamenstellingComponent
} from './corporate/fiscale-eenheid-samenstelling/fiscale-eenheid-samenstelling.component';
import {VrijgesteldeWinstComponent} from './corporate/vrijgestelde-winst/vrijgestelde-winst.component';
import {AdministratieKoppelenComponent} from './corporate/administratie-koppelen/administratie-koppelen.component';
import {SpecAgrarischComponent} from './corporate/spec-agrarisch/spec-agrarisch.component';
import {OverzichtComponent} from './corporate/overzicht/overzicht.component';
import {SpecOpenActivaComponent} from './corporate/spec-open-activa/spec-open-activa.component';
import {SpecSlotActivaComponent} from './corporate/spec-slot-activa/spec-slot-activa.component';
import {SpecOpenPassivaComponent} from './corporate/spec-open-passiva/spec-open-passiva.component';
import {SpecSlotPassivaComponent} from './corporate/spec-slot-passiva/spec-slot-passiva.component';
import {SharedUiAlertModule} from '@snelstart/ui-alert';
import {SpecGebouwenComponent} from './corporate/spec-gebouwen/spec-gebouwen.component';
import {
  SpecOmzetbelastingPassiefComponent
} from './corporate/spec-omzetbelasting-passief/spec-omzetbelasting-passief.component';
import {
  SpecCorrectiesBijzonderhedenComponent
} from './corporate/spec-correcties-bijzonderheden/spec-correcties-bijzonderheden.component';
import {
  FiscaleEenheidVerliezenComponent
} from './corporate/fiscale-eenheid-verliezen/fiscale-eenheid-verliezen.component';
import {
  SpecMachinesEnInstallatiesComponent
} from './corporate/spec-machines-en-installaties/spec-machines-en-installaties.component';
import {SpecAndereVasteActivaComponent} from './corporate/spec-andere-vaste-activa/spec-andere-vaste-activa.component';
import {SharedUiContextMenuModule} from '@snelstart/ui-context-menu';
import {SharedUiTooltipTriggerModule} from '@snelstart/ui-tooltip-trigger';
import {SharedUiTooltipModule} from '@snelstart/ui-tooltip';
import {SharedUiIconModule} from '@snelstart/ui-icon';
import {NietAftrekbareRenteComponent} from './corporate/niet-aftrekbare-rente/niet-aftrekbare-rente.component';
import {AftrekbareGiftenComponent} from './corporate/culturele-giften/aftrekbare-giften.component';
import {GewoneGiftenComponent} from './corporate/culturele-giften/gewone-giften/gewone-giften.component';
import {CultureleGiftenComponent} from './corporate/culturele-giften/culturele-giften/culturele-giften.component';
import {ToelichtingenTekstComponent} from './corporate/toelichtingen-tekst/toelichtingen-tekst.component';
import {
  TekstVrijgesteldeWinstComponent
} from './corporate/toelichtingen-tekst/tekst-vrijgestelde-winst/tekst-vrijgestelde-winst.component';
import {
  TekstBeperktAftrekbareKostenComponent
} from './corporate/toelichtingen-tekst/tekst-beperkt-aftrekbare-kosten/tekst-beperkt-aftrekbare-kosten.component';
import {
  TekstNietAftrekbareRenteComponent
} from './corporate/toelichtingen-tekst/tekst-niet-aftrekbare-rente/tekst-niet-aftrekbare-rente.component';
import {
  TekstInvesteringsaftrekComponent
} from './corporate/toelichtingen-tekst/tekst-investeringsaftrek/tekst-investeringsaftrek.component';
import {
  TekstInvesteringenOverigComponent
} from './corporate/toelichtingen-tekst/tekst-investeringen-overig/tekst-investeringen-overig.component';
import {
  TekstAftrekbareCultureleGiftenComponent
} from './corporate/toelichtingen-tekst/tekst-aftrekbare-culturele-giften/tekst-aftrekbare-culturele-giften.component';
import {
  TekstVerliesverrekeningComponent
} from './corporate/toelichtingen-tekst/tekst-verliesverrekening/tekst-verliesverrekening.component';
import {
  TekstBalansActivaComponent
} from './corporate/toelichtingen-tekst/tekst-balans-activa/tekst-balans-activa.component';
import {
  TekstBalansPassivaComponent
} from './corporate/toelichtingen-tekst/tekst-balans-passiva/tekst-balans-passiva.component';
import {
  TekstResultatenrekeningComponent
} from './corporate/toelichtingen-tekst/tekst-resultatenrekening/tekst-resultatenrekening.component';
import {
  TekstVermogensvergelijkingComponent
} from './corporate/toelichtingen-tekst/tekst-vermogensvergelijking/tekst-vermogensvergelijking.component';
import {
  TekstVragenVoorafComponent
} from './corporate/toelichtingen-tekst/tekst-vragen-vooraf/tekst-vragen-vooraf.component';
import {
  TekstBelastingplichtigeComponent
} from './corporate/toelichtingen-tekst/tekst-belastingplichtige/tekst-belastingplichtige.component';
import {
  TekstAdministratieKoppelenComponent
} from './corporate/toelichtingen-tekst/tekst-administratie-koppelen/tekst-administratie-koppelen.component';
import {
  TekstSpecDividenduitkeringenComponent
} from './corporate/toelichtingen-tekst/tekst-spec-dividenduitkeringen/tekst-spec-dividenduitkeringen.component';
import {
  TekstSpecAandeelhoudersComponent
} from './corporate/toelichtingen-tekst/tekst-spec-aandeelhouders/tekst-spec-aandeelhouders.component';
import {
  TekstSpecDeelnemingenComponent
} from './corporate/toelichtingen-tekst/tekst-spec-deelnemingen/tekst-spec-deelnemingen.component';
import {
  TekstBelastingbedragComponent
} from './corporate/toelichtingen-tekst/tekst-belastingbedrag/tekst-belastingbedrag.component';
import {
  TekstSamenstellingFiscaleEenheidComponent
} from './corporate/toelichtingen-tekst/tekst-samenstelling-fiscale-eenheid/tekst-samenstelling-fiscale-eenheid.component';
import {
  TekstVragenFiscaleEenheidComponent
} from './corporate/toelichtingen-tekst/tekst-vragen-fiscale-eenheid/tekst-vragen-fiscale-eenheid.component';
import {SharedUiListModule} from '@snelstart/ui-list';
import {SharedUiLoadingModule} from '@snelstart/ui-loading';
import {NietAftrekbareBoetesComponent} from './corporate/niet-aftrekbare-boetes/niet-aftrekbare-boetes.component';
import {OverigeGiftenComponent} from './corporate/overige-giften/overige-giften.component';
import {
  TekstBelastbaarbedragComponent
} from './corporate/toelichtingen-tekst/tekst-belastbaarbedrag/tekst-belastbaarbedrag.component';
import {
  TekstAftrekbareGewoneGiftenComponent
} from './corporate/toelichtingen-tekst/tekst-aftrekbare-gewone-giften/tekst-aftrekbare-gewone-giften.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiAlertModule,
    SharedUiContextMenuModule,
    SharedUiTooltipTriggerModule,
    SharedUiTooltipModule,
    SharedUiIconModule,
    TekstVragenVoorafComponent,
    TekstBelastingplichtigeComponent,
    TekstAdministratieKoppelenComponent,
    TekstSpecDividenduitkeringenComponent,
    TekstSpecAandeelhoudersComponent,
    TekstSpecDeelnemingenComponent,
    TekstBelastingbedragComponent,
    TekstSamenstellingFiscaleEenheidComponent,
    TekstVragenFiscaleEenheidComponent,
    SharedUiListModule,
    SharedUiLoadingModule,
    TekstBelastbaarbedragComponent, FeatureTaxCorporateDetailsComponent,
    CorporateComponent,
    AlgemeenComponent,
    BelastingplichtigeComponent,
    VragenFiscaleEenheidComponent,
    ResultatenRekeningComponent,
    VermogensVergelijkingComponent,
    AandeelhoudersComponent,
    DeelnemingenComponent,
    InvesteringenComponent,
    BelastingBedragComponent,
    BalansActivaComponent,
    BalansPassivaComponent,
    DividendsComponent,
    BeperktAftrekbareKostenComponent,
    VerliezenComponent,
    OverigeKostenComponent,
    OverigeGiftenComponent,
    RenteComponent,
    WillekeurigAfschrijvenComponent,
    FunctioneleValutaComponent,
    FiscaleEenheidVoegingComponent,
    FiscaleEenheidOntvoegingComponent,
    FiscaleEenheidOntbindingComponent,
    InnovatieboxComponent,
    BronheffingComponent,
    EnkelvoudigeCijfersComponent,
    SpecOmzetbelastingComponent,
    SpecHirComponent,
    SpecGarantievoorzieningComponent,
    SpecKerComponent,
    SpecCompartimenteringComponent,
    SpecOverigeVoorzieningComponent,
    SpecHir2Component,
    FiscaleEenheidSamenstellingComponent,
    VrijgesteldeWinstComponent,
    AdministratieKoppelenComponent,
    SpecAgrarischComponent,
    OverzichtComponent,
    SpecOpenActivaComponent,
    SpecSlotActivaComponent,
    SpecOpenPassivaComponent,
    SpecSlotPassivaComponent,
    SpecGebouwenComponent,
    SpecMachinesEnInstallatiesComponent,
    SpecOmzetbelastingPassiefComponent,
    SpecCorrectiesBijzonderhedenComponent,
    FiscaleEenheidVerliezenComponent,
    SpecAndereVasteActivaComponent,
    NietAftrekbareRenteComponent,
    AftrekbareGiftenComponent,
    NietAftrekbareBoetesComponent,
    GewoneGiftenComponent,
    CultureleGiftenComponent,
    ToelichtingenTekstComponent,
    VrijgesteldeWinstComponent,
    TekstVrijgesteldeWinstComponent,
    TekstBeperktAftrekbareKostenComponent,
    TekstNietAftrekbareRenteComponent,
    TekstInvesteringsaftrekComponent,
    TekstInvesteringenOverigComponent,
    TekstAftrekbareCultureleGiftenComponent,
    TekstVerliesverrekeningComponent,
    TekstBalansActivaComponent,
    TekstBalansPassivaComponent,
    TekstResultatenrekeningComponent,
    TekstVermogensvergelijkingComponent,
    TekstAftrekbareGewoneGiftenComponent
  ],
  declarations: [],
  exports: [FeatureTaxCorporateDetailsComponent, SpecMachinesEnInstallatiesComponent]
})
export class FeatureTaxCorporateDetailsModule {
}
